import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    background: "rgba(0, 0, 0, 0.80)",
    backdropFilter: "blur(5px)",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    top: 0,
    position: "fixed",
    zIndex: theme.zIndex.dialog,
  },
  tabs: {
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
  },
  service: {
    display: "flex",
    flexDirection: "column",
    marginTop: 70,
    justifyContent: "space-between",
  },
  rowService: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  rowAllTab: {
    padding: `0 ${theme.spacing.space16}px`,
  },
  launchpads: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 16,
  },
  forwardsAnimate: {
    animation: `$forwardsAnimate 0.3s ease-in forwards`,
    overflow: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  backwardsAnimate: {
    animation: `$backwardsAnimate 0.3s ease-in forwards`,
    overflow: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  icon: {
    color: theme.colors.Background7,
  },
  imgGame: {
    borderRadius: 24,
  },
  title: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": 1,
    textAlign: "center",
  },
  divider: {
    height: 1,
    background:
      "linear-gradient(90deg, rgba(255, 255, 255, 0.30) 0%, #FFF 51.44%, rgba(255, 255, 255, 0.30) 100%)",
    margin: [24, 0],
  },
  "@keyframes forwardsAnimate": {
    "0%": {
      transform: "translateY(-100%)",
    },
    "100%": {
      transform: "translateY(0%)",
    },
  },
  "@keyframes backwardsAnimate": {
    "0%": {
      transform: "translateY(0%)",
    },
    "100%": {
      transform: "translateY(-100%)",
    },
  },
}));
